<template>
  <div class="video_box home" v-if="url">
    <div class="container">
      <div class="player">
        <video-player
          class="video-player vjs-custom-skin video-swiper"
          :ref="refName"
          :playsinline="true"
          :options="playerOptions"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
        ></video-player>
      </div>
    </div>
  </div>
</template>
 
<script>
import { videoPlayer } from "vue-video-player";
import { mapMutations } from "vuex";
export default {
  props:{
    url: {
      type: String,
      default:""
    },
    refName:{
      type:String,
      default:""
    },
    time:{
      type:Number,
    },
    cover:{
      type:String,
    }
  },
  data() {
    return {
      videoUrl:"",
      playerOptions: {
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: this.url
          }
        ],
        poster: this.url, //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      state: "",
      paused: "",
      running: ""
    };
  },
  created() {
    this.ind
    if (this.url) {
      if(this.cover){
        this.videoUrl = this.cover;
      } else if(this.time){
        this.videoUrl = `${this.url}?x-oss-process=video/snapshot,t_${this.time},f_jpg,w_590,h_332,m_fast`;
      }
      this.playerOptions = {
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: this.url
          }
        ],
        poster: this.videoUrl, //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      };
      const that = this;
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  components: {
    videoPlayer
  },
  methods: {
    // ...mapMutations({
    //   setVideoOpen: "setVideoOpen"
    // }),
    onPlayerPlay(player) {
      this.$emit('onPlayerPlay');
    },
    onPlayerPause(player) {
      this.$emit('onPlayerPause',this.ind);
    },
    //轮播改变
    swiperChange(){
      // console.log('接受');
      this.$refs[this.refName].player.pause();
    }
  }
};
</script>

<style lang="scss" scoped>
.video_box{
  &.home{
    ::v-deep .container{
      .player{
        .video-swiper{
          .vjs-big-play-button{
            transform: scale(0.8);
          }
          .vjs-control-bar{
            opacity: 1;
            .vjs-volume-panel,.vjs-current-time,.vjs-time-control,.vjs-duration,.vjs-progress-control{
              display: none;
            }
            // .vjs-play-control{
            //   .vjs-icon-placeholder{
            //     &::before{

            //     }
            //   }
            // }
            .vjs-fullscreen-control{
              margin-left: auto;
              .vjs-icon-placeholder{
                display: flex;
                width: 100%;
                height: 100%;
                &::before{
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100%;
                  line-height: initial;
                }
              }
            }
          }
        }
      }
    }
  }
}
.container {
  background-color: #f5f5f5;
  min-height: 100%;
  
}
.video_box,
.container,
.player,
.video-player {
  height: 100%;
  // touch-action: none;
}
.vjs-custom-skin > .video-js .vjs-control-bar{
  font-size: 0.24rem;
}
</style> 